import imageOne from '@/assets/images/cities/oakville1.jpg'
import imageTwo from '@/assets/images/cities/oakville2.jpg'
import imageThree from '@/assets/images/cities/oakville3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Oakville',
  writeup: '',
  website: 'MyOakvilleNotaryPublic.com',
  url: 'https://www.myoakvillenotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '',
      hours: {
        monday: '6:00PM to 9:00PM',
        tuesday: '6:00PM to 9:00PM',
        wednesday: '6:00PM to 9:00PM',
        thursday: '6:00PM to 9:00PM',
        friday: '6:00PM to 9:00PM',
        saturday: '',
        sunday: ''
      },
      address: 'Gooseberry Road Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/oakville.js